import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.concat.js";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (g && (g = 0, op[0] && (_ = 0)), _) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

import Cookies from 'js-cookie';
import { SENCE_LABEL } from '@/const';
import { _trans } from '@/lib/i18next';
import { appendPrompt } from '@/plugins/Prompt';
import Toast from '@/plugins/Toast';
import { postActiveAddress } from '@/services/landing';
import { isJoJoBrowser, isWXAppBrowser, isWXBrowser, isWXMiniAppBrowser, localUrlJump, urlJump } from '@/utils';
import { hasClass } from '@/utils/dom';
import { sensClickInitiative, sensElementView } from '@/utils/sensors';
import { getCampaignStr, handleFlag40 } from '../businessCode';
var isJoJoApp = isJoJoBrowser();
var isProInner = isJoJoApp || isWXBrowser() || uc_switch;
var frontendInside = isJoJoApp || isWXBrowser();
var unionid = '';

if (isWXAppBrowser()) {
  unionid = Cookies.get('wxUnionId');
} else if (isWXMiniAppBrowser()) {
  unionid = Cookies.get('minUnionId') || Cookies.get('wxUnionId');
} // 渲染提示


export var renderPrompt = function renderPrompt(_a) {
  var _b = _a === void 0 ? {} : _a,
      title = _b.title,
      content = _b.content,
      btnText = _b.btnText,
      btnText2 = _b.btnText2,
      hideBtnText = _b.hideBtnText,
      tutorialLink = _b.tutorialLink,
      className = _b.className,
      hasSecondeBtn = _b.hasSecondeBtn;

  return (
    /* html */
    "\n    <div class=\"ui-prompt-selection ".concat(className || '', "\">\n      <h4 class=\"tit\">").concat(title || '报名已结束', "</h4>\n      <div class=\"desc\">").concat(content || '下期报名即将开始', "</div>\n      <div class=\"").concat(btnText2 ? 'panel' : '', "\">\n      ").concat(btnText2 && hasSecondeBtn ? "<button  class=\"btn3\">".concat(btnText2, "</a>") : '', "\n      ").concat(btnText2 && tutorialLink ? "<a href=\"".concat(tutorialLink, "\" class=\"btn2 ").concat(hasSecondeBtn ? 'second' : '', "\">").concat(btnText2, "</a>") : '', "\n      ").concat(!hideBtnText ? "<button class=\"btn\">".concat(btnText || _trans('courseSelection.prompt.btnKnow'), "</button>") : '', "\n      </div>\n    </div>\n    ")
  );
};
export var renderCode7Prompt = function renderCode7Prompt(_a) {
  var _b = _a === void 0 ? {} : _a,
      title = _b.title,
      btnText = _b.btnText,
      btnText2 = _b.btnText2,
      phone = _b.phone,
      className = _b.className;

  return "<div class=\"ui-prompt-selection-code7 ".concat(className || '', "\">\n      <h4 class=\"tit\">").concat(title || '报名已结束', "</h4>\n      <div class=\"desc\">\u60A8\u672C\u8D26\u53F7\u5DF2\u4E0E<span>").concat(phone, "</span>\u7ED1\u5B9A<br/>\u9700\u89E3\u7ED1\u540E\u518D\u9886\u53D6\u5F53\u524D\u5185\u5BB9</div>\n      <div class=\"tip\"><img src='").concat(cdnPath, "images/alart.png' class='tip-icon' />\u89E3\u7ED1\u540E\u5C06\u65E0\u6CD5\u5B66\u4E60<span>").concat(phone, "</span>\u7684\u5185\u5BB9\uFF0C\u4E14\u8BE5\u64CD\u4F5C\u65E0\u6CD5\u6062\u590D</div>\n      <div class=\"panel\">\n        <button class=\"btn-left\">").concat(btnText || _trans('courseSelection.prompt.btnKnow'), "</button>\n        <button class=\"btn-right\">").concat(btnText2 || _trans('courseSelection.prompt.btnKnow'), "</button>\n      </div>\n    </div>");
};
export var renderNewPrompt = function renderNewPrompt(_a) {
  var title = _a.title,
      content = _a.content,
      btnText = _a.btnText,
      btnText2 = _a.btnText2,
      showClose = _a.showClose;
  return "<div class=\"ui-prompt-selection-pop\">\n    ".concat(showClose ? "<div class=\"pop-close\">\n      <svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 20\" fill=\"none\">\n        <path d=\"M5.55039 3.28286C5.06223 2.79471 4.27078 2.79471 3.78262 3.28286C3.29447 3.77102 3.29447 4.56248 3.78262 5.05063L8.73207 10.0001L3.78262 14.9495C3.29447 15.4377 3.29447 16.2291 3.78262 16.7173C4.27078 17.2055 5.06223 17.2055 5.55039 16.7173L10.4998 11.7678L15.4493 16.7173C15.9374 17.2055 16.7289 17.2055 17.2171 16.7173C17.7052 16.2291 17.7052 15.4377 17.2171 14.9495L12.2676 10.0001L17.2171 5.05063C17.7052 4.56248 17.7052 3.77102 17.2171 3.28286C16.7289 2.79471 15.9374 2.79471 15.4493 3.28286L10.4998 8.23231L5.55039 3.28286Z\" fill=\"#666666\"/>\n        <rect x=\"0.5\" width=\"20\" height=\"20\" fill=\"black\" fill-opacity=\"0.01\"/>\n      </svg>\n    </div>" : '', "\n    ").concat(title ? "<h4 class=\"tit\">".concat(title, "</h4>") : '', "\n    <div class=\"desc\">").concat(content || '', "</div>\n    <div class=\"panel\">\n      ").concat(btnText2 ? "<button class=\"btn-left\">".concat(btnText2 || _trans('courseSelection.prompt.btnKnow'), "</button>\n           <button class=\"btn-right\">").concat(btnText, "</button>") : "<button class=\"btn-center\">".concat(btnText || _trans('courseSelection.prompt.btnKnow'), "</button>"), "\n    </div>\n  </div>");
};
export var newPromptFunc = function newPromptFunc(ops) {
  Toast.hide();
  appendPrompt({
    content: renderNewPrompt(ops),
    hideCloseIcon: ops.hideCloseIcon,
    onClose: function onClose() {
      if (typeof ops.onClose === 'function') {
        ops.onClose();
      }
    },
    onMount: function onMount(content) {
      var $content = content;

      $content.onclick = function (e) {
        var _a;

        var ev = e || window.event;

        if (ops.stopPropagation !== false) {
          ev.stopPropagation();
        }

        var target = ev.target || ev.srcElement;

        if (target && hasClass(target, 'btn-left')) {
          if (ops.onLeftBtnClick) {
            ops.onLeftBtnClick($content);
            return;
          }

          if (ops.clickClose || ops.clickClose === undefined) {
            $content.onclick = null;
            document.body.removeChild($content);
          }
        }

        if (target && hasClass(target, 'btn-center')) {
          // SP118 新增事件点击方法
          if (ops.onCenterBtnClick) {
            ops.onCenterBtnClick($content);
            return;
          }

          if (ops.clickClose || ops.clickClose === undefined) {
            $content.onclick = null;
            document.body.removeChild($content);
          }
        }

        if (target && hasClass(target, 'btn-right')) {
          if (typeof ops.onOk === 'function') {
            ops.onOk();
          }

          if (ops.clickClose || ops.clickClose === undefined) {
            $content.onclick = null;
            document.body.removeChild($content);
          }
        } // 新增顶部pop-close按钮关闭事件


        if (target && hasClass(target, 'pop-close')) {
          (_a = ops === null || ops === void 0 ? void 0 : ops.onClose) === null || _a === void 0 ? void 0 : _a.call(ops);
          $content.onclick = null;
          document.body.removeChild($content);
        }
      };
    }
  });
};
export var promptFunc = function promptFunc(ops) {
  Toast.hide();
  appendPrompt({
    content: (ops === null || ops === void 0 ? void 0 : ops.code) === 7 ? renderCode7Prompt(ops) : renderPrompt(ops),
    hideCloseIcon: ops.hideCloseIcon,
    onClose: function onClose() {
      if (typeof ops.onClose === 'function') {
        ops.onClose();
      }
    },
    onMount: function onMount(content) {
      var $content = content;

      $content.onclick = function (e) {
        var ev = e || window.event;

        if (ops.stopPropagation !== false) {
          ev.stopPropagation();
        }

        var target = ev.target || ev.srcElement; // 立即报名

        if (target && hasClass(target, 'btn')) {
          if (ops.clickClose || ops.clickClose === undefined) {
            $content.onclick = null;
            document.body.removeChild($content);
          }

          if (typeof ops.onOk === 'function') {
            ops.onOk();
          }
        }

        if (target && hasClass(target, 'btn3')) {
          if (ops.clickClose || ops.clickClose === undefined) {
            $content.onclick = null;
            document.body.removeChild($content);
          }
        }

        if ((ops === null || ops === void 0 ? void 0 : ops.code) === 7) {
          if (target && hasClass(target, 'btn-left')) {
            if (ops.clickClose || ops.clickClose === undefined) {
              $content.onclick = null;
              document.body.removeChild($content);
            }
          }

          if (target && hasClass(target, 'btn-right')) {
            if (typeof ops.onOk === 'function') {
              ops.onOk();
            }

            if (ops.clickClose || ops.clickClose === undefined) {
              $content.onclick = null;
              document.body.removeChild($content);
            }
          }
        }
      };
    }
  });
};
export function toClassSelect(frontOrderResp, campaignStr) {
  if (isProInner) {
    var soldCode = frontOrderResp.soldCode;

    if (soldCode) {
      urlJump("/exchange/select?snid=".concat(soldCode).concat(campaignStr || ''));
    }
  }
} // 售卖单激活流程

export var toActivate = function toActivate(_a, rootData) {
  var soldId = _a.soldId,
      skuId = _a.skuId,
      addressId = _a.addressId,
      abtest = _a.abtest,
      _b = _a.soldIdCode,
      soldIdCode = _b === void 0 ? '' : _b,
      _c = _a.version,
      version = _c === void 0 ? '' : _c;
  return __awaiter(void 0, void 0, void 0, function () {
    var params, resp, _d, data, resultCode, errorMsg, campaignStr, soldNoteList, _e, directAddTeacher, id, soldCode, needAnswer, fetr, item, _f, courseId, soldNoteId, classId, _g, avatarUrl, nickname, queryParams;

    var _h, _j;

    return __generator(this, function (_k) {
      switch (_k.label) {
        case 0:
          if (addressId) {
            params = {
              soldNoteId: soldId,
              userAddressId: addressId
            };
          } else {
            params = {
              soldNoteId: soldId
            };
          }

          return [4
          /*yield*/
          , postActiveAddress(__assign(__assign({}, params), {
            soldIdCode: soldIdCode,
            frontendInside: frontendInside,
            // 考虑到第三方小程序，优先取unionId。unionId在同一主体下是相同的
            unionid: unionid // 暂时不用添加scene

          }))];

        case 1:
          resp = _k.sent();
          _d = resp || {}, data = _d.data, resultCode = _d.resultCode, errorMsg = _d.errorMsg;
          campaignStr = getCampaignStr(rootData);

          if (!data || resultCode !== 200) {
            Toast.fail(errorMsg || _trans('courseSelection.toast.systemErr'), 1);
            return [2
            /*return*/
            , null];
          }

          soldNoteList = data.soldNoteList;

          if (data.flagCode === 3 && Array.isArray(soldNoteList) && soldNoteList.length) {
            _e = soldNoteList[0] || {}, directAddTeacher = _e.directAddTeacher, id = _e.id, soldCode = _e.soldCode, needAnswer = _e.needAnswer; // 直加老师

            if (directAddTeacher && id) {
              localUrlJump("/transferPage.html?oid=".concat(id || '').concat(campaignStr, "&direct=1"), true);
              return [2
              /*return*/
              , null];
            } // 答题逻辑


            if (soldCode && needAnswer) {
              urlJump("/exchange/select?snid=".concat(soldCode).concat(campaignStr));
              return [2
              /*return*/
              , null];
            }
          }

          if ((soldIdCode || version === '2.0' || version === '3.0') && data.flagCode === 3) {
            fetr = (data === null || data === void 0 ? void 0 : data.frontEventTrackResp) || {};
            item = data.soldNoteList[0];
            urlJump("/address/edit?oid=".concat(item.id || '', "&sid=").concat(item.skuId, "&abtest=").concat(abtest || fetr.abtest || '').concat(campaignStr));
            return [2
            /*return*/
            , null];
          } // 检查到不能购买
          // 站内已有同科目课程，跳转到加老师页
          // SP130 修改pick-up-solid 接口 跳转到中转页。新增version 3.0判断


          if (data.flagCode === 1) {
            if (version === '3.0') {
              // eslint-disable-next-line consistent-return
              return [2
              /*return*/
              , true];
            }

            _f = data.frontClassResp, courseId = _f.courseId, soldNoteId = _f.soldNoteId, classId = _f.classId;
            localUrlJump("/transferPage.html?cid=".concat(courseId || '', "&oid=").concat(soldNoteId || soldId || '', "&sid=").concat(skuId || '', "&clsid=").concat(classId || '').concat(campaignStr));
            return [2
            /*return*/
            , null];
          } // 激活时是子账号
          // 子账号


          if (data.flagCode === 7) {
            sensors.quick('autoTrack', {
              fail_reason: "".concat(data.flagCode),
              custom_state: 'addTeacherError'
            });

            if (!data.frontUserResp) {
              Toast.fail(_trans('courseSelection.prompt.switchAccounts'), 1);
              return [2
              /*return*/
              , null];
            }

            _g = data.frontUserResp || {}, avatarUrl = _g.avatarUrl, nickname = _g.nickname;
            queryParams = ["code=".concat(data.flagCode), "name=".concat(nickname), "url=".concat(encodeURIComponent(avatarUrl))];
            urlJump("/error?".concat(queryParams.join('&')));
            return [2
            /*return*/
            , null];
          }

          if (data.flagCode === 400) {
            sensors.quick('autoTrack', {
              sku_id: skuId,
              fail_reason: "".concat((_j = (_h = data === null || data === void 0 ? void 0 : data.frontErrorResp) === null || _h === void 0 ? void 0 : _h.flagCode) !== null && _j !== void 0 ? _j : data === null || data === void 0 ? void 0 : data.flagCode),
              custom_state: 'addTeacherError'
            });

            if (data.frontErrorResp.flagCode === 411) {
              promptFunc({
                title: _trans('courseSelection.prompt.titleHint'),
                content: _trans('courseSelection.prompt.ctNotSatisfied'),
                btnText: _trans('courseSelection.prompt.btnKnow')
              });
            } else {
              handleFlag40(data.frontErrorResp);
            }
          }

          return [2
          /*return*/
          , null];
      }
    });
  });
};
/**
 * 去激活modal弹框逻辑
 * @param needShip
 * @param courseName
 * @param courseId
 * @param soldNoteId
 * @param setActivateModal
 * @param abtest
 */

export var toOrderModal = function toOrderModal(_a, rootData) {
  var needShip = _a.needShip,
      subjectContent = _a.subjectContent,
      courseId = _a.courseId,
      soldNoteId = _a.soldNoteId,
      abtest = _a.abtest,
      viewReport = _a.viewReport,
      clickReport = _a.clickReport,
      hasFrontOrderResp = _a.hasFrontOrderResp,
      frontOrderResp = _a.frontOrderResp;
  sessionStorage.removeItem(SENCE_LABEL);
  var campaignStr = getCampaignStr(rootData);

  if (viewReport) {
    sensElementView(viewReport);
  }

  if (needShip) {
    promptFunc({
      title: _trans('courseSelection.prompt.titleRecur'),
      content: subjectContent,
      btnText: _trans('courseSelection.prompt.btnActivate'),
      btnText2: '知道了',
      hasSecondeBtn: true,
      hideCloseIcon: true,
      onOk: function onOk() {
        if (clickReport) {
          sensClickInitiative(clickReport);
        }

        if (hasFrontOrderResp && isProInner) {
          toClassSelect(frontOrderResp, campaignStr);
        } else {
          urlJump("/address/edit?cid=".concat(courseId || '', "&oid=").concat(soldNoteId || '', "&abtest=").concat(abtest).concat(campaignStr));
        }
      }
    });
  } else {
    promptFunc({
      title: _trans('courseSelection.prompt.titleRecur'),
      content: subjectContent,
      btnText: _trans('prompt.btn.activation'),
      btnText2: '知道了',
      hasSecondeBtn: true,
      hideCloseIcon: true,
      onOk: function onOk() {
        if (clickReport) {
          sensClickInitiative(clickReport);
        }

        if (hasFrontOrderResp && isProInner) {
          toClassSelect(frontOrderResp, campaignStr);
        } else {
          toActivate({
            soldId: soldNoteId,
            abtest: abtest,
            history: 'replace'
          }, rootData);
        }
      }
    });
  }
};